export enum Bakgrundsfärg {
  Primär,
  Sekundär,
}

export enum ContentTypeBase {
  Link = 'Link',
  Page = 'Page',
  Block = 'Block',
  Folder = 'Folder',
  Media = 'Media',
  Image = 'Image',
  Video = 'Video',
}

export enum ContentTypeGuid {
  // "Page"-typer:
  Standardsida = '1e795e93-4b05-40a0-9a96-0fcc93b3c541',
  Samlingssida = 'fc18ab62-2482-4b51-ac1a-7a6ff597c808',
  Nyhet = '0d3c1d6b-a1d7-408f-8eff-32c6fe149b20',
  Nyhetsarkiv = '2b54b51e-94f6-44b4-98eb-501f4229e306',
  Kalenderhändelsearkiv = '3153b53e-43f6-4d76-897a-5ddf451e8c86',
  Kalenderhändelse = '2620ea88-e284-4aa6-a75d-f9acd8470a7a',
  Sidfot = '1afb832c-b023-4530-b9d6-b1721a96dc47',
  Driftmeddelande = '9b72dfe2-f942-4a5d-bbca-fde43d9a3af0',
  // "Block"-typer:
  XhtmlTextBlock = '0180b1a1-57ba-4374-893a-333721132a5d',
  NyhetsBlock = 'd5f0e39d-b7f0-4575-8198-d8f07bb26009',
  RubrikBlock = 'e73f8359-838c-4edc-8f94-243af6850644',
  HeroknappBlock = 'b93a04ec-2449-4fe5-8b25-96b32caae6f7',
  Sidfotblock = 'fc8c1823-b4bc-47c1-b70c-8c35c6d7e418',
  AccordionBlock = '1d874c4d-9a6d-4a63-872d-c14dc8c0990c',
  AccordionGroupBlock = '9372ce7e-b878-412a-95f7-aece8f51878a',
  KalenderhändelseBlock = '9b85e8ae-3b15-4846-9dcb-b7e6b96c039e',
  KursBlock = 'ff8bde1f-7b54-49a4-a385-2bd65252a228',
  FlikgruppBlock = '8badcf7e-19d8-4229-924e-582fe9a421e8',
  FlikBlock = '76e64f72-6ca5-4e50-a6f2-aa6450f09997',
  NamnBlock = '6f84b742-9df0-4e28-8589-3c05d6a9b3f9',
  TabellBlock = '3fdeb63e-db7f-490d-b905-5b1a2eb0869b',
  YoutubeBlock = '5a232317-15b7-40e9-aac3-5d4999541e21',
  // "Image"-typer:
  Bildfil = '95856249-b53f-4c9d-b199-a4c21f56e98c',
  // "Media"-typer:
  PdfFil = 'b55341ed-515c-4a87-815e-e9468b9c3201',
  DocOchDocxFil = '4ef873d8-36db-4c6e-adb8-8a33f5c287cc',
  PptOchPptxFil = '2d7d27d5-533a-4858-ac31-7a9b3873ed62',
  XlsOchXlsxFil = '0bbb9989-745e-49b5-9f40-9b4c026cddeb',
}

export enum DisplayOption {
  Full = 'full',
  TwoThirds = 'twothirds',
  Half = 'half',
  OneThird = 'onethird',
}

// export enum VersionStatus {
//   NotCreated = 0,
//   Rejected = 1,
//   CheckedOut = 2,
//   CheckedIn = 3,
//   Published = 4,
//   PreviouslyPublished = 5,
//   DelayedPublish = 6,
//   AwaitingApproval = 7,
// }
